import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("luma_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const streamChat = async (sessionId, content, onDelta, onDone, onError) => {
  const token = localStorage.getItem("luma_token");
  try {
    const res = await fetch(`${API}/sessions/${sessionId}/messages`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ content }),
    });
    if (!res.ok) {
      const t = await res.text();
      onError?.(t || "Request failed");
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      const parts = buf.split("\n\n");
      buf = parts.pop() || "";
      for (const chunk of parts) {
        if (!chunk.trim()) continue;
        if (chunk.startsWith("event: done")) {
          onDone?.();
          return;
        }
        const line = chunk.split("\n").find((l) => l.startsWith("data: "));
        if (line) {
          const data = line.slice(6);
          if (data === "[DONE]") {
            onDone?.();
            return;
          }
          onDelta?.(JSON.parse(data));
        }
      }
    }
    onDone?.();
  } catch (e) {
    onError?.(e.message || "Stream error");
  }
};
